import _ from 'lodash';

import { AssignTaskBorrowerTargetEnum } from 'constants/loanActionEditor';
import { LoanContactTypeEnum } from 'constants/loanContactTypes';
import { loanContactTypesOptions } from 'constants/options';

const BORROWER_TARGET_BY_CONTACT_TYPE = {
  [LoanContactTypeEnum.Borrower1]: AssignTaskBorrowerTargetEnum.BORROWER_1,
  [LoanContactTypeEnum.Borrower2]: AssignTaskBorrowerTargetEnum.BORROWER_2,
  [LoanContactTypeEnum.Borrower3]: AssignTaskBorrowerTargetEnum.BORROWER_3,
  [LoanContactTypeEnum.Borrower4]: AssignTaskBorrowerTargetEnum.BORROWER_4,
};

const BORROWER_FULL_NAME_HINT =
  "Add {Borrower full name} to the task type's name so each borrower sees their own name on their task.";

export const ALL_BORROWERS_HELPER_TEXT = `Creates one task per borrower. ${BORROWER_FULL_NAME_HINT}`;

export const SELECTED_BORROWERS_HELPER_TEXT = `Creates one task for each selected borrower; a borrower the loan doesn't have is skipped. ${BORROWER_FULL_NAME_HINT}`;

export const PRESELECT_BORROWERS_LINK_TEXT = 'Preselect borrowers';

export const USE_PRIMARY_BORROWER_LINK_TEXT = 'Use default (primary borrower)';

export const assignTaskBorrowerTargetOptions = [
  { name: 'All borrowers', value: AssignTaskBorrowerTargetEnum.ALL_BORROWERS },
  ...loanContactTypesOptions
    .filter(({ value }) => _.has(BORROWER_TARGET_BY_CONTACT_TYPE, value))
    .map(({ name, value }) => ({ name, value: BORROWER_TARGET_BY_CONTACT_TYPE[value] })),
];

export const primaryBorrowerTargetOptions = assignTaskBorrowerTargetOptions.filter(
  ({ value }) => value === AssignTaskBorrowerTargetEnum.BORROWER_1,
);
